import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Input } from '@1trading/react/components/ui/input';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { OWNERSHIP_TYPES } from '@/constants/institution';
import type { InstitutionOwnershipOrDefaults } from '@/features/institution/ownership/schema';

const InstitutionOwnershipFieldsetType = () => {
  const form = useFormContext<InstitutionOwnershipOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="ownershipType"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.ownership.type.ownershipType')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.ownership.type.ownershipType')} onValueChange={field.onChange}>
                {OWNERSHIP_TYPES.map((ownershipType) => (
                  <FormItem key={ownershipType}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={ownershipType} />
                      </FormControl>
                      <FormLabel contained>{t(`institutionDetails.ownership.type.options.${ownershipType}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="bearerSharesPct"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.ownership.type.bearerSharesPct.title')}*</FormLabel>
            <FormDescription>{t('institutionDetails.ownership.type.bearerSharesPct.description')}</FormDescription>
            <FormControl>
              <Input
                {...field}
                className="no-spinner"
                inputMode="decimal"
                placeholder={t('institutionDetails.ownership.placeholders.percentage')}
                type="number"
                value={field.value ?? ''}
                onChange={(event) => field.onChange(event.target.value === '' ? undefined : Number(event.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionOwnershipFieldsetType.displayName = 'InstitutionOwnershipFieldsetType';

export { InstitutionOwnershipFieldsetType };
